var map = {
	"./file-default.svg": 8865,
	"./file-jpg.svg": 4963,
	"./file-pdf.svg": 2628,
	"./file-png.svg": 9979,
	"./ic-advantages.svg": 6858,
	"./ic-become_partner.svg": 3172,
	"./ic-campus.svg": 6191,
	"./ic-cancel.svg": 7138,
	"./ic-check.svg": 7308,
	"./ic-configurator.svg": 4767,
	"./ic-documentation.svg": 3706,
	"./ic-downloads.svg": 6311,
	"./ic-edit.svg": 6672,
	"./ic-education.svg": 5726,
	"./ic-find_partner.svg": 3902,
	"./ic-first_steps.svg": 9606,
	"./ic-inflation_stop.svg": 4453,
	"./ic-info.svg": 4632,
	"./ic-invoices.svg": 756,
	"./ic-library.svg": 1405,
	"./ic-message_center.svg": 3191,
	"./ic-new_ticket.svg": 6834,
	"./ic-orders.svg": 839,
	"./ic-overview.svg": 9557,
	"./ic-partner_guidelines.svg": 5504,
	"./ic-partner_programm.svg": 3384,
	"./ic-planning.svg": 7607,
	"./ic-products.svg": 7096,
	"./ic-references.svg": 3658,
	"./ic-reg_shield.svg": 350,
	"./ic-settings.svg": 5443,
	"./ic-support_faq.svg": 5716,
	"./ic-tickets.svg": 1187,
	"./ic-trainings.svg": 2337,
	"./ic-webshop.svg": 1674,
	"./ic-website.svg": 8763
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5853;